// removed by extract-text-webpack-plugin
module.exports = {"Categories":"_1q2Hno_FvmqHfvfu5FNeB7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Categories/Categories.css
// module id = 248
// module chunks = 0